import { render, staticRenderFns } from "./ContributionDashboard.vue?vue&type=template&id=781cc22c&scoped=true"
import script from "./ContributionDashboard.vue?vue&type=script&lang=ts"
export * from "./ContributionDashboard.vue?vue&type=script&lang=ts"
import style0 from "./ContributionDashboard.vue?vue&type=style&index=0&id=781cc22c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781cc22c",
  null
  
)

export default component.exports